import useLazyByProject from './useLazyByProject';
import { getGate, getOverview } from '../services/QualityService';

const covers = (loaded, wanted) => loaded === 'full' || loaded === wanted;

/**
 * The quality of each project of a workspace, lazily and two at a time (services/QualityService.js): its release gate
 * (cheap: what blocks Publish) and, with `full`, every check of its last run (the Quality tab's matrix). Returns
 * `{ entries, reload }` as `useLazyByProject`; a value is `{ gate, checks }` (`checks` null until `full` was read), and
 * a project the sandbox cannot answer for (an older vfs-service, no access) is an entry with status 'error'.
 */
export default function useWorkspaceQuality(projectIds, { full = false, enabled = true } = {}) {
  return useLazyByProject(projectIds, async(projectId, mode) => {
    if (mode === 'full') {
      const overview = await getOverview(projectId);
      return { gate: overview?.gate || null, checks: overview?.checks || {} };
    }
    const answer = await getGate(projectId);
    return { gate: answer?.gate || null, checks: null };
  }, { enabled, concurrency: 2, mode: full ? 'full' : 'gate', covers });
}
